import React from "react";

const SelectComponent = ({ img, h4Option ,pOption, selectType, selectValue, onSelected=() => {}, price=''}) => {

    return (
    <button
        className={`option-button ${selectType === selectValue ? 'active' : ''} card_component`}
        onClick={() => onSelected(selectValue)}
    >
        <img src={img} alt={selectValue}/>
        <div className="option-button__details">
            <h4>{h4Option}</h4>
            <p>{pOption}</p>
        </div>
        <p>{price}</p>
    </button>
    )
}

export default SelectComponent;